export default "__VITE_ASSET__52bc632f__"